import React from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_USER_DISPLAY_STATUSES } from '@/constants';
import type { AdminUserDisplayStatus } from '@/constants';
import styles from './styles.module.scss';

const LABEL_KEYS: Record<AdminUserDisplayStatus, string> = {
  [ADMIN_USER_DISPLAY_STATUSES.BLOCKED]: 'admin:userStatusBlocked',
  [ADMIN_USER_DISPLAY_STATUSES.PENDING]: 'admin:userStatusPending',
  [ADMIN_USER_DISPLAY_STATUSES.UNVERIFIED]: 'admin:userStatusUnverified',
  [ADMIN_USER_DISPLAY_STATUSES.ACTIVE]: 'admin:userStatusActive',
};

export interface UserStatusPillProps {
  status: AdminUserDisplayStatus;
}

/** Account status badge used by the admin users table and mobile row cards. */
export const UserStatusPill: React.FC<UserStatusPillProps> = ({ status }) => {
  const { t } = useTranslation('admin');
  return <span className={`${styles.pill} ${styles[status]}`}>{t(LABEL_KEYS[status])}</span>;
};

export default UserStatusPill;
